import styled from 'styled-components';

import { theme } from '@styles/theme';

export const ShareContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
`;

export const CopyContainer = styled.div((p) => ({
  backgroundColor: theme.color.purpleTrans5,
  borderRadius: '2px',
  display: 'flex',
  fontSize: '16px',
  justifyContent: 'space-between',
}));

export const CareerLink = styled.div((p) => ({
  color: theme.color.purple100,
  margin: '10px 10px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const SocialShareButton = styled.div((p) => ({
  height: '2.5rem',
  padding: '0 0.5rem',
  alignItems: 'center',
  backgroundColor: theme.color[p.backgroundColor],
  borderRadius: '2px',
  color: '#fff',
  cursor: 'pointer',
  display: 'flex',
  fontSize: '14px',
  opacity: '1',
  span: {
    marginLeft: '8px',
  },
  ':hover': {
    backgroundColor: theme.color[p.onHoverColor],
  },
}));
